import axios from "axios";
import { useMessage } from "@/hooks/useMessage";
import store from "@/store";
// const store = useStore();

const service = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
  // 根据项目所处的环境，自动加载所需的url地址 使用了proxy 代理服务器就不用basseURl
  baseURL: process.env.VUE_APP_URL,

  // 请求超时时间
  timeout: 1000 * 60 * 2, //2分钟ss
});

// 添加请求拦截器
service.interceptors.request.use(
  function (config) {
    // console.log("请求拦截器", config);
    const token = store.state.user.token;
    // 在发送请求之前给 header 设置 token
    if (token && !config.url.includes("/user/login")) {
      config.headers = {
        Authorization: token,
      };
      // console.log("请求拦截器", config);
    }
    // 一定要返回config
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  // 拦截响应
  (response) => {
    // 判断响应状态码
    if (response.status !== 200) {
      // console.log(response);
      const message = response.data.message;
      if (message) {
        useMessage(message, "error");
        const pathname = window.location.pathname;
        // 判断当前页面是否为登录页面
        if (pathname !== "/login") {
          if (message === "身份认证失败！") {
            store.commit("user/logout");
            return;
          }
        }
      }
      return Promise.reject(response);
    } else {
      return response.data;
    }
  },
  // 拦截错误
  (err) => {
    // console.log("拦截错误", err);
    // 拦截错误
    if (err.response) {
      // console.log("拦截错误", err.response);
      // 请求失败
      if (err.response.status === 400) {
        if (err.response.data.data !== null) {
          useMessage(err.response.data.data.message, "error");
          // store.commit("user/logout");
          return err;
        } else {
          useMessage(err.response.data.message, "error");
        }
        return err;
      }
      // 认证失败
      if (err.response.status === 401) {
        const message = err.response.data.message;
        useMessage("认证失败", "error");
        const pathname = window.location.pathname;
        // 判断当前页面是否为登录页面
        if (pathname !== "/login") {
          if (message === "Unauthorized") {
            store.commit("user/logout");
            return err;
          }
        }
        return err;
      }
      // 权限不足
      if (err.response.status === 403) {
        useMessage("没有权限访问！", "error");
        return;
      }
      // 未找到
      if (err.response.status === 404) {
        useMessage("请求地址不存在！", "error");
        return;
      }
      // 服务器错误
      if (err.response.status === 500) {
        useMessage("服务器错误！", "error");
        return err;
      }
      // 其他错误
      useMessage(err.message, "error");
      return err;
    }
    // 网络错误
    if (err.message.includes("Network Error")) {
      useMessage("网络错误，请检查网络连接！", "error");
      return err;
    }
    // 其他错误
    useMessage(err.message, "error");
    return err;
  }
);

export default service;
